export default __webpack_public_path__ + "static/media/component-details.e8878e82.png";